import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { EColiPostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWaterQualitySlice/EColiSlice';
import { EcoliDataDDL } from '../../../../../../Components/CommonDDL/EcoliDataDDL';

export default function WaterQualityEcoliPagePopup(props) {

    const { RoleID, handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [EcoliField, setEcoliFieldField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        wardName: Flag === 'Update' ? rowData.wardName : '',
        locationDetails: Flag === 'Update' ? rowData.locationDetails : '',
        turibidity: Flag === 'Update' ? rowData.turibidity : '',

    })
    const [EcoliDDL, setEcoliDDL] = useState({
        DDL: [],
        ID: rowData.m_IndicatorEcoliID,
        Label: rowData.indicatorName,

    })

    const handleEcoliFieldField = (e) => {
        setEcoliFieldField({ ...EcoliField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_WS_WaterQualityEcoliID: Flag == 'Update' ? rowData.t_wS_WaterQualityEcoliID : '0',
            T_Distri_WaterQualityEcoliID: Flag == 'Update' ? rowData.t_Distri_WaterQualityEcoliID : '0',
            T_TTP_WaterQualityTDSID: Flag == 'Update' ? rowData.t_ttP_WaterQualityTDSID : '0',
            M_IndicatorTDSID: EcoliDDL.ID,
            M_IndicatorEcoliID: EcoliDDL.ID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(EColiPostDataAPI({ data }))

    }

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quality-{DashProjectTypeId == '9' ? 'TDS' : 'E-Coli'}</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                        <input type="date" className="form-control"
                                            name='locationName'
                                            aria-describedby="emailHelp"
                                            disabled
                                            value={EcoliField.readingDate}
                                            onChange={(e) => handleEcoliFieldField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
                                        <input type="text" className="form-control"
                                            name='wardName'
                                            aria-describedby="emailHelp"
                                            disabled
                                            value={EcoliField.wardName}
                                            onChange={(e) => handleEcoliFieldField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                        <input type="text" className="form-control"
                                            name='locationName'
                                            aria-describedby="emailHelp"
                                            disabled
                                            value={EcoliField.locationDetails}
                                            onChange={(e) => handleEcoliFieldField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <EcoliDataDDL
                                            EcoliDDL={EcoliDDL}
                                            setEcoliDDL={setEcoliDDL}
                                            rowData={rowData}
                                            DashProjectTypeId={DashProjectTypeId}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}